<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div *ngIf="loading" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only ">Loading...</span>
    </div>
</div>

<ng-container *ngIf="!loading">
    <div style="background-color:#eaf1f5; position: sticky; top: 0; z-index: 100;">
        <!-- navigation -->
        <div class="all-container">
            <div class="row no-gutters nav-bar pt-1">
                <div (click)="changePge(1)" class="py-2 px-3">
                    <div class="pb-1" [ngStyle]="page==1 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                        Account
                    </div>
                </div>
                <div (click)="changePge(2)" class="py-2 px-3">
                    <div class="pb-1" [ngStyle]="page==2 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                        Google Account
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div *ngIf="page == 2" class="editor-container d-flex justify-content-center align-items-center">
        <div class="card mx-3 mt-2 w-100" style="border-radius: 10px;">
            <app-google-account-settings></app-google-account-settings>
        </div>
    </div>
    
    <div *ngIf="page == 1">
        <div class="alert alert-info py-2 px-2 my-1 mx-2" role="alert">
            <ul class="mb-0 pl-3 " style="font-size:12px;">
                <li>In this profile, you can set your customer care numbers.</li>
                <li>Customers can see these numbers on their M-bill.</li>
                <li>You can also set the number from which customer SMS will be sent.</li>
            </ul>
        </div>
    
        <div class="p-3 " style="background-color: white; min-height: 100%;">
            <div class="d-flex flex-column py-2">
                <div class="d-flex align-items-center justify-content-between">
                    <div style="color: #757575; font-size: 18px; font-weight: 600;">Company Info</div>
                    <div class="d-flex align-items-center justify-content-end">
                        <button class="ml-1" [ngClass]="isSellerDetailsEdit ? 'cancel-btn': 'edit-btn' "
                            (click)="toggleCompanyInfoEdit()">
                            {{ isSellerDetailsEdit ? 'Cancel' : 'Edit' }}
                        </button>
                        <button (click)="updateBranchProfile()" class="edit-btn ml-1"
                            *ngIf="isSellerDetailsEdit">Save</button>
                    </div>
                </div>
    
                <form *ngIf="!isSellerDetailsEdit" [formGroup]="CompanyInfoForm">
                    <div class="d-flex flex-column mt-2" style="gap: 0.75rem;">
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Company Name :</div>
                            <input type="text" class="form-control input-field" formControlName="BranchName" />
                        </div>
    
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Admin Name :</div>
                            <input type="text" class="form-control input-field" formControlName="AdminName" />
                        </div>
    
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Address :</div>
                            <input type="text" class="form-control input-field" formControlName="BranchAddress" />
                        </div>
    
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Place :</div>
                            <input type="text" class="form-control input-field" formControlName="Place" />
                        </div>
    
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Customer Care 1 :</div>
                            <input type="text" class="form-control input-field" formControlName="CustomerCare1" />
                            <div class="d-flex align-items-center mt-2">
                                <input formControlName="checkBox1" class="customerCare-checkbox mr-2" type="checkbox"
                                    id="skip">
                                <span id="skip" class=" field-label mb-0">Show on SMS/WhatsApp</span>
                            </div>
                        </div>
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Customer Care 2 :</div>
                            <input type="text" class="form-control input-field" formControlName="CustomerCare2" />
                            <div class="d-flex align-items-center mt-2">
                                <input formControlName="checkBox2" class="customerCare-checkbox mr-2" type="checkbox"
                                    id="skip">
                                <span id="skip" class=" field-label mb-0">Show on SMS/WhatsApp</span>
                            </div>
                        </div>
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Customer Care 3 :</div>
                            <input type="text" class="form-control input-field" formControlName="CustomerCare3" />
                            <div class="d-flex align-items-center mt-2">
                                <input formControlName="checkBox3" class="customerCare-checkbox mr-2" type="checkbox"
                                    id="skip">
                                <span id="skip" class=" field-label mb-0">Show on SMS/WhatsApp</span>
                            </div>
                        </div>
    
                    </div>
                </form>
    
                <form *ngIf="isSellerDetailsEdit" [formGroup]="CompanyInfoForm">
                    <div class="d-flex flex-column mt-2" style="gap: 0.75rem;">
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Company Name :</div>
                            <input type="text" class="form-control input-field" formControlName="BranchName" />
                        </div>
    
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Admin Name :</div>
                            <input type="text" class="form-control input-field" formControlName="AdminName" />
                        </div>
    
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Address :</div>
                            <input type="text" class="form-control input-field" formControlName="BranchAddress" />
                        </div>
    
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Place :</div>
                            <input type="text" class="form-control input-field" formControlName="Place" />
                        </div>
    
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Customer Care 1 :</div>
                            <input type="text" class="form-control input-field" formControlName="CustomerCare1" />
                            <div class="d-flex align-items-center mt-2" (click)="setSMSNumber(1)">
                                <input formControlName="checkBox1" class="customerCare-checkbox mr-2" type="checkbox"
                                    id="skip">
                                <span id="skip" class=" field-label mb-0">Show on SMS/WhatsApp</span>
                            </div>
                        </div>
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Customer Care 2 :</div>
                            <input type="text" class="form-control input-field" formControlName="CustomerCare2" />
                            <div class="d-flex align-items-center mt-2" (click)="setSMSNumber(2)">
                                <input formControlName="checkBox2" class="customerCare-checkbox mr-2" type="checkbox"
                                    id="skip">
                                <span id="skip" class=" field-label mb-0">Show on SMS/WhatsApp</span>
                            </div>
                        </div>
                        <div class="d-flex flex-column" style="font-size: 14px;">
                            <div style="color: #673AB7; font-size: 13px;">Customer Care 3 :</div>
                            <input type="text" class="form-control input-field" formControlName="CustomerCare3" />
                            <div class="d-flex align-items-center mt-2" (click)="setSMSNumber(3)">
                                <input formControlName="checkBox3" class="customerCare-checkbox mr-2" type="checkbox"
                                    id="skip">
                                <span id="skip" class=" field-label mb-0">Show on SMS/WhatsApp</span>
                            </div>
                        </div>
    
                    </div>
                </form>
            </div>
            <hr class="w-100 my-1">
    
            <div class="d-flex flex-column py-2">
                <app-service-unique-id></app-service-unique-id>
            </div>
            <hr class="w-100 my-1">
    
            <div class="d-flex flex-column py-2">
                <div style="color: #757575; font-size: 18px; font-weight: 600;">Delete All Data</div>
                <div class="d-flex flex-column mt-2" style="gap: 0.5rem;">
                    <p class="m-0" style="font-size: 11px;">
                        Delete all data will clear all data saved in this application
                        forever,
                        at any circumstance the data cannot be retrieved by the company or developer or admin.
                    </p>
                </div>
                <div class="mt-2">
                    <button class="btn btn-outline-danger w-100 " (click)="deleteAllData();" style="font-size: 13px;">
                        Delete All Data
                    </button>
                </div>
            </div>
            <hr class="w-100 my-1">
        </div>
    </div>
</ng-container>




<div *ngIf="isShowDeleteAllPopUp" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <p style="font-size: 18px;">Do you really want to delete all data ?</p>
                <div class="d-flex align-items-center justify-content-end " style="gap: 0.5rem;">
                    <button type="button" id="btnAddServices" class="btn btn-outline-secondary w-25"
                        data-dismiss="modal" (click)="closeDeleteAllPopup();" style="font-size: 14px;">No</button>
                    <button type="button" id="btnContinue" class="btn btn-primary w-25"
                        style="background-color: #673AB7; color: #fff; border: #673AB7;font-size: 14px;"
                        (click)="ConfirmDeleteAllData();">Yes</button>
                </div>
            </div>
        </div>
    </div>
</div>